export default __webpack_public_path__ + "static/media/icon-idea-process.5445f200.svg";